import { render } from "./ConfirmUpdateForm.vue?vue&type=template&id=28d3960f"
import script from "./ConfirmUpdateForm.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__